import { Component, OnInit } from '@angular/core';
import { BusinessTransactionDto, BusinessTransactionService } from '@app/api/dmc';
import { TabsComponent } from '@shared/components/tabs/tabs.component';
import { TabComponent } from '@shared/components/tabs/tab/tab.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Columns } from '@shared/interfaces/table/column-config';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { ValueDetailsComponent } from '@shared/components/value-details/value-details.component';
import { AlertService } from '@app/core/services/alert.service';
import { LoadingService } from '@app/core/services/loading.service';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

@Component({
  selector: 'app-show-businesstransaction-modal',
  imports: [
    TabsComponent,
    TabComponent,
    TranslatePipe,
    ValueDetailsComponent
  ],
  templateUrl: './show-businesstransaction-modal.component.html',
  styleUrl: './show-businesstransaction-modal.component.css'
})
export class ShowBusinesstransactionModalComponent implements OnInit {

  /** Inherited Element **/
  public businessTransaction!: BusinessTransactionDto;

  public showBusinesstransactionMasterdata: Columns<BusinessTransactionDto>[] = [
    {
      title: 'meteringpoint.identification',
      key: 'meteringPointIdentification',
    },
    {
      title: 'Transaktionstype',
      key: 'pipelineType',
      cellRenderer: TranslateCellComponent,
      cellRendererParams:
        {
          notspecified: 'enum.pipelinetype.notspecified',
          request: 'enum.pipelinetype.request',
          response: 'enum.pipelinetype.response',
          notify: 'enum.pipelinetype.notify',
          todo: 'enum.pipelinetype.todo',
          todohandled: 'enum.pipelinetype.todohandled',
        }
    },
    {
      title: 'meteringpoint.businesstransaction.show.rsmname',
      key: 'rsmName',
    },
    {
      title: 'meteringpoint.businesstransaction.show.rsmnumber',
      key: 'rsmNumber',
    },
    {
      title: 'meteringpoint.businesstransaction.show.brcreasoncode',
      key: 'businessReasonCode',
    },
    {
      title: 'meteringpoint.businesstransaction.show.reasoncode',
      key: 'reasonCode',
    },
    {
      title: 'meteringpoint.businesstransaction.show.reason',
      key: 'reasonText',
    },
    {
      title: 'meteringpoint.businesstransaction.show.respondedby',
      key: 'respondedBy',
    },
    {
      title: 'meteringpoint.businesstransaction.show.respondeddate',
      key: 'respondedTS',
      cellRenderer: DateCellComponent,
    },
    {
      title: 'meteringpoint.businesstransaction.show.actionrespondedby',
      key: 'actionRespondedBy',
    },
    {
      title: 'meteringpoint.businesstransaction.show.actionrespondedts',
      key: 'actionRespondedTS',
      cellRenderer: DateCellComponent,
    },
    {
      title: 'common.changedate',
      key: 'occurrence',
      cellRenderer: DateCellComponent,
    },
    {
      title: 'meteringpoint.businesstransaction.show.createdby',
      key: 'createdBy',
    },
    {
      title: 'meteringpoint.businesstransaction.show.createddate',
      key: 'createdTS',
      cellRenderer: DateCellComponent,
    },
  ];

  public id?: string;

  public type?: string;

  constructor(
    private readonly businessTransactionService: BusinessTransactionService,
    private readonly alertService: AlertService,
    private readonly loadingService: LoadingService,
  ) {
  }

  public ngOnInit(): void {
    this.fetchData()
  }

  public fetchData(): void {
    if (this.id) {
      if (this.type === 'chargeinformation') {
        this.showBusinesstransactionMasterdata.splice(5, 6);
        this.showBusinesstransactionMasterdata.splice(0, 1, {
          title: 'chargeInformation.table.type',
          key: 'chargeInformationIdentification',
        });
      }

      this.loadingService.start()
      this.businessTransactionService.businessTransactionGetByIdGet(this.id).subscribe({
        next: (result: BusinessTransactionDto) => {
          this.businessTransaction = result;

          if (result.rsmText) {
            this.businessTransaction.rsmText = this.tryFormatJson(result.rsmText) ?? this.tryFormatXml(result.rsmText) ?? result.rsmText;
          }
        },
        error: (error) => {
          this.alertService.open('modal', 'danger', error);
        },
        complete: () => {
          this.loadingService.stop()
        }
      })
    }
  }

  private tryFormatJson(rawJson: string): string | null {
    try {
      return JSON.stringify(JSON.parse(rawJson.trim()), null, 2);
    } catch {
      return null;
    }
  }

  private tryFormatXml(rawXml: string): string | null {
    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(rawXml, 'application/xml');
      if (typeof XSLTProcessor === "undefined" || xmlDoc.querySelector('parsererror')) return null;

      const xsl = `
    <xsl:stylesheet version="1.0"
      xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
      <xsl:output method="xml" indent="yes" omit-xml-declaration="yes"/>
      <xsl:strip-space elements="*"/>
      <xsl:template match="@*|node()">
        <xsl:copy><xsl:apply-templates select="@*|node()"/></xsl:copy>
      </xsl:template>
    </xsl:stylesheet>`.trim();

      const xslDoc = parser.parseFromString(xsl, 'application/xml');
      const proc = new XSLTProcessor();
      proc.importStylesheet(xslDoc);

      const doc = proc.transformToDocument(xmlDoc);
      return new XMLSerializer().serializeToString(doc);
    } catch {
      return null;
    }
  }
}
